import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { PdfSpacerFormComponent } from './pdf-spacer-form.component';
import { RnplCommonModule } from 'common/src/modules';


@NgModule({
  declarations: [
    PdfSpacerFormComponent
  ],
  exports: [
    PdfSpacerFormComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RnplCommonModule,
    NgSelectModule,
    TranslateModule,
  ],
  providers: []
})
export class PdfSpacerFormModule { }
